/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownTravelDocument } from '../models/db_DropdownTravelDocument';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TravelDocuments {
    /**
     * Get a list of travel documents
     * @param programmes Programmes
     * @returns db_DropdownTravelDocument OK
     * @throws ApiError
     */
    public static listTravelDocuments(
        programmes?: string,
    ): CancelablePromise<Array<db_DropdownTravelDocument>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/travel-documents',
            query: {
                'programmes': programmes,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
